import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../../i18n";

export const Products = () => {
  const { t } = useLang();
  const products = [
    {
      id: "box",
      tag: t("pr.box_tag"),
      t: t("pr.box_t"),
      d: t("pr.box_d"),
      img: "/img/box-branded.webp",
      cls: "lg:col-span-7 lg:row-span-2 min-h-[420px] lg:min-h-[640px]",
    },
    {
      id: "multibox",
      tag: t("pr.mb_tag"),
      t: t("pr.mb_t"),
      d: t("pr.mb_d"),
      img: "/img/dark.jpg",
      cls: "lg:col-span-5 lg:row-span-2 min-h-[300px]",
    },
  ];

  const Card = ({ p }) => (
    <a
      href="#contatti"
      data-testid={`product-card-${p.id}`}
      className={`group relative overflow-hidden flex flex-col justify-end p-8 lg:p-10 text-[#F3EFE6] ${p.cls}`}
    >
      <img src={p.img} alt={p.t} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/90 via-[#1C1917]/35 to-transparent" />
      <div className="relative">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#E2C9A6]">{p.tag}</p>
        <div className="mt-3 flex items-end justify-between gap-6">
          <h3 className="font-serif text-3xl lg:text-5xl font-light break-words">{p.t}</h3>
          <span className="w-12 h-12 shrink-0 rounded-full border border-[#F3EFE6]/60 flex items-center justify-center transition-[background-color,transform] duration-500 group-hover:bg-[#C18A53] group-hover:rotate-45">
            <ArrowUpRight className="w-5 h-5" />
          </span>
        </div>
        <p className="mt-4 max-w-md text-sm md:text-base text-[#E7E2DA] leading-relaxed">{p.d}</p>
      </div>
    </a>
  );

  return (
    <section id="prodotti" data-testid="products-section" className="py-24 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-7">
            <Reveal><Eyebrow>{t("pr.eyebrow")}</Eyebrow></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#1C1917]">
                {t("pr.h2a")} <em className="text-[#9A4930]">{t("pr.h2em")}</em>{t("pr.h2b")}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="lg:col-span-5 flex items-end">
            <p className="text-base md:text-lg text-[#57534E] leading-relaxed">{t("pr.p")}</p>
          </Reveal>
        </div>
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-12 lg:grid-rows-2 gap-4 lg:gap-6">
            {products.map((p) => <Card key={p.id} p={p} />)}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
